<div class="card-wrape m-b-0">
    <div class="card-head with-dropdown">
        <h4 class="left-text">Disease Wise Participant Count</h4>
        <div class="right-control">
            <div class="input-wrape">
                <div class="control-pad">
                    <ng-select [items]="percentageOrAbsoluteCounts" [clearable]="false" [dropdownPosition]="'bottom'"
                        [searchable]="false" placeholder="Please Select" bindLabel="value" bindValue="id"
                        [(ngModel)]="diseaseWisePercentOrCount"
                        (change)="showRecordsInPercentOrAbsoluteCount('disease_wise', $event)">
                    </ng-select>
                </div>
            </div>
        </div>
    </div>
    <div class="card-body">
        <mat-spinner *ngIf="diseaseChartLoader"></mat-spinner>
        <div class="progress-overlay"></div>
        <div *ngIf="totalDiseaseChartCounts == 0 && !diseaseChartLoader; else foundDiseaseChartData">
            <div class="no-data-found">
                <div class="no-data-container">
                    <div class="no-data-icon"></div>
                    <div class="no-data-text">NO DATA FOUND</div>
                </div>
            </div>
        </div>
        <ng-template #foundDiseaseChartData>
            <div echarts [options]="options" class="echart" style="height: 490px;"></div>
            <div class="total-count-piechart">{{totalDiseaseChartCounts}}<span>Total</span></div>
        </ng-template>
    </div>
</div>